// extracted by mini-css-extract-plugin
export default {"BtnReportIssue":"ReportIssueCTA_BtnReportIssue__LIb0D","rotation":"ReportIssueCTA_rotation__AOaSr"};